const PROFILE_CACHE_TTL_MS = 2 * 60 * 1000;

type ProfileCacheEntry = {
  profile: any;
  cachedAt: number;
};

const profileCache = new Map<string, ProfileCacheEntry>();

export function getCachedProfile(userId: string): any | null {
  const entry = profileCache.get(userId);
  if (!entry) return null;

  const isExpired = Date.now() - entry.cachedAt > PROFILE_CACHE_TTL_MS;
  if (isExpired) {
    profileCache.delete(userId);
    return null;
  }

  return entry.profile;
}

export function setCachedProfile(userId: string, profile: any): void {
  if (!userId || !profile) return;
  profileCache.set(userId, { profile, cachedAt: Date.now() });
}

export function clearCachedProfile(userId?: string): void {
  if (!userId) {
    profileCache.clear();
    return;
  }
  profileCache.delete(userId);
}
